import * as Yup from 'yup';

export const getFilteredCollections = (promptCollections, createdCollections) => {
  const systemFields = [
    'Id',
    'Created At',
    'Created By',
    'Updated By',
    'Is Deleted',
    'Updated At',
    'Version',
  ];

  const filterSystemFields = (fields = []) => {
    return fields.filter((field) => {
      const title = field.fieldTitle.en.toLowerCase().trim();
      return !systemFields.map((s) => s.toLowerCase().trim()).includes(title);
    });
  };

  const map = new Map();

  [...promptCollections, ...createdCollections].forEach((item) => {
    map.set(item.collectionTitle, item);
  });

  const uniqueCollections = Array.from(map.values());

  const filteredCollections = uniqueCollections
    .map((collection) => ({
      ...collection,
      fields: filterSystemFields(collection.fields),
    }))
    .filter((collection) => collection.fields.length > 0);

  return filteredCollections;
};
export const aiPromptValidationSchema = Yup.object().shape({
  aiPrompt: Yup.string().required('Prompt cannot be empty'),
});
export const promptRolesValidationSchema = Yup.object().shape({
  roles: Yup.array()
    .of(Yup.string().trim().required('Role name is required'))
    .min(1, 'At least one role is required'),
});
export const iconStyle = {
  position: 'absolute',
  top: '50%',
  right: '10px',
  transform: 'translateY(-50%)',
  fontSize: '1.1rem',
};

export const validationSchema = Yup.object().shape({
  pages: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Page name is required'),
      description: Yup.string().required('Page description is required'),
    }),
  ),
});
export const EXCLUDED_COLLECTIONS = ['role', 'user', 'organisation'];

export function getUniqueRolesByName(roles) {
  if (!Array.isArray(roles) || roles.length === 0) {
    console.warn('getUniqueRolesByName: roles is not a valid non-empty array.');
    return [];
  }
  const seen = new Set();
  return roles.filter((role) => {
    if (!role || typeof role.name !== 'string') {
      console.warn('Invalid role object:', role);
      return false;
    }
    if (seen.has(role.name)) return false;
    seen.add(role.name);
    return true;
  });
}



